import { IBase } from './base-finance.interface';

export interface ICurrency extends IBase {
  code: string;
  name: string;
  value: string;
  exchange?: string;
}
